import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type StockSliderClasses =
  | 'root'
  | 'sliderContainer'
  | 'verticalOffset'
  | 'leftArrow'
  | 'rightArrow'
  | 'hideNext'
  | 'interiorViewArrow';

const stockSliderStyles = makeStyles<ISpcTheme, StockSliderClasses>(
  theme => ({
    root: {
      zIndex: 999,
      '& .slick-slide': {
        height: 'initial',
        marginRight: 20,
        '&:last-of-type': {
          marginRight: 0,
        },
      },
    },
    sliderContainer: {
      padding: '0 10px 20px',
      maxWidth: '100%',
      overflow: 'hidden',
      paddingBottom: '20px',
      '& .slick-initialized': {
        padding: '0 50px 25px',
      },
    },
    verticalOffset: {
      top: 194,
    },
    leftArrow: {
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
      },
    },
    rightArrow: {
      [theme.breakpoints.down('sm')]: {
        paddingRight: 0,
      },
    },
    hideNext: {
      opacity: 0,
      userSelect: 'none',
      pointerEvents: 'none',
    },
    interiorViewArrow: {
      '& svg': {
        color: theme.palette.common.white,
      },
    },
  }),
  { name: 'GqlCustomise_StockSlider' },
);

export default stockSliderStyles;
